import { get } from 'lodash'

export default function () {
  if (get(this.$route, 'params.id', null) !== null) {
    this.person.dweller_guest_list_id = get(this.$route, 'params.id', null)
    this.getPersons()
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/list/resources/mounted.js